"use strict";exports.assignRef=function(t,n){return"function"==typeof t?t(n):t&&(t.current=n),t};
//# sourceMappingURL=assignRef.js.map
